<template>
    <div class="mt-4 w-100 d-flex align-items-center justify-content-start">
        <img :src="ShieldCheckIcon" class="mr-2" />
        <em class="mb-0" v-bind:class="{ 'fs-12': increaseFontSize }" style="color: blue">Dokumen medis digital ini sah diterbitkan {{ KlinikInformation.KlinikName }}
            dan diproses komputer menggunakan Aplikasi Izidok
        </em>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'SuratPenunjangFormBaseDigitalSign',
    computed: {
        ...mapState('SuratPenunjangStore', ['KlinikInformation',]),
        ...mapGetters('SuratPenunjangStore', ['ShieldCheckIcon'])
    },
    props: {
        increaseFont: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            increaseFontSize: true
        }
    },
    watch: {
        increaseFont: {
            immediate: true,
            deep: true,
            handler(val) {
                if(!val){
                    this.increaseFontSize = false
                }
            }
        }
    }
}
</script>